import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DayPickerRangeController } from 'react-dates';

import moment from 'utils/moment';

import { Item, Row } from 'components/Layout';

import { BaseDateWrapper, MonthSelect } from './style';

const YEARS_BEFORE = 10;
const YEARS_AFTER = 2;

const MonthYearSelect = ({ month, onMonthSelect, onYearSelect }) => {
  const currentYear = moment().year();
  const selectableYears = Array.from(
    { length: YEARS_BEFORE + YEARS_AFTER + 1 },
    (_unusedValue, index) => currentYear - YEARS_BEFORE + index
  );

  return (
    <Row spacing={0} justify="center" alignItems="center">
      <Item flex justify="center">
        <MonthSelect
          value={month.month()}
          onChange={event => onMonthSelect(month, Number(event.target.value))}
        >
          {moment.months().map((monthLabel, monthIndex) => (
            <option key={monthIndex} value={monthIndex}>
              {monthLabel}
            </option>
          ))}
        </MonthSelect>
      </Item>
      <Item flex justify="center">
        <MonthSelect
          value={month.year()}
          onChange={event => onYearSelect(month, Number(event.target.value))}
        >
          {selectableYears.map(year => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </MonthSelect>
      </Item>
    </Row>
  );
};

const DayPickerRangeControllerWrapper = props => {
  const {
    autoFocusEndDate,
    startDate,
    endDate,
    renderCalendarInfo,
    minimumNights,
    onDatesChange,
    datePickerKey
  } = props;

  const [focusedInput, setFocusInput] = useState(
    autoFocusEndDate ? 'endDate' : 'startDate'
  );

  const onFocusChange = input => {
    setFocusInput(!input ? 'startDate' : input);
  };

  const handleDatesChange = ({ startDate: newStart, endDate: newEnd }) => {
    if (startDate && endDate) {
      const clickedDate = newStart || newEnd;
      onDatesChange({ startDate: clickedDate, endDate: null });
      setFocusInput('endDate');
      return;
    }
    if (newStart && !newEnd && startDate && newStart.isBefore(startDate, 'day')) {
      onDatesChange({ startDate: newStart, endDate: null });
      return;
    }
    onDatesChange({ startDate: newStart, endDate: newEnd });
  };

  return (
    <BaseDateWrapper>
      <DayPickerRangeController
        key={datePickerKey}
        onDatesChange={handleDatesChange}
        onFocusChange={onFocusChange}
        focusedInput={focusedInput}
        startDate={startDate}
        endDate={endDate}
        calendarInfoPosition="before"
        renderCalendarInfo={renderCalendarInfo}
        renderMonthElement={MonthYearSelect}
        orientation="horizontal"
        numberOfMonths={2}
        minimumNights={minimumNights}
        hideKeyboardShortcutsPanel
        initialVisibleMonth={
          endDate && startDate
            ? () => (focusedInput === 'endDate' ? endDate : startDate)
            : null
        }
      />
    </BaseDateWrapper>
  );
};

DayPickerRangeControllerWrapper.propTypes = {
  autoFocusEndDate: PropTypes.bool,
  minimumNights: PropTypes.number,
  renderCalendarInfo: PropTypes.node,
  startDate: PropTypes.instanceOf(moment),
  endDate: PropTypes.instanceOf(moment),
  onDatesChange: PropTypes.func,
  datePickerKey: PropTypes.string
};
DayPickerRangeControllerWrapper.defaultProps = {
  autoFocusEndDate: false,
  startDate: null,
  endDate: null,
  minimumNights: 0,
  renderCalendarInfo: null,
  onDatesChange: () => {},
  datePickerKey: 'defaultKey'
};

export default DayPickerRangeControllerWrapper;
